/**
 * Task status
 */
const taskStatusLabelObject = {
    NOT_STARTED: "Not Started",
    IN_PROGRESS: "In Progress",
    COMPLETED: "Completed",
    WAITING_ON_CLIENT: "Waiting on Client",
    WAITING_ON_THIRD_PARTY: "Waiting on Third Party",
    WAITING_ON_ADVISOR: "Waiting on Advisor",
    WAITING_ON_CUSTODIAN: "Waiting on Custodian",
    CANCELED: "Canceled",
};
const taskStatusLabelTuples = Object.entries(taskStatusLabelObject).map(([key, value]) => [key, value]);
export const mapTaskStatusToLabel = (taskStatus) => {
    const tuple = taskStatusLabelTuples.find(([thisStatus, _label]) => thisStatus === taskStatus);
    if (tuple === undefined) {
        throw new Error(`Tuple did not have ${taskStatus}`);
    }
    return tuple[1];
};
export const mapLabelToTaskStatus = (taskLabel) => {
    const tuple = taskStatusLabelTuples.find(([_thisStatus, label]) => label === taskLabel);
    if (tuple === undefined) {
        throw new Error(`Tuple did not have ${taskLabel}`);
    }
    return tuple[0];
};
/**
 * Task type
 */
const taskTypeLabelObject = {
    ACCOUNT_OPENING: "Account Opening",
    ACCOUNT_MAINTENANCE: "Account Maintenance",
    ACCOUNT_TRANSFER: "Account Transfer (ACAT)",
    TRADE_REQUEST: "Trade Request",
    ALTERNATIVE_INVESTMENT: "Alternative/SMA Investment",
    STANDING_INSTRUCTIONS: "Standing Instructions",
    MONEY_MOVEMENT: "Money Movement",
    LIQUIDATION: "Raise Cash",
    OTHER: "Other",
};
const taskTypeLabelObjectV2 = {
    ...taskTypeLabelObject,
    ACCOUNT_TRANSFER: "Account Transfer",
    OTHER: "Advisor Request",
    BUGS_AND_ENGINEERING_REQUESTS: "Bugs & Engineering Requests",
    FINANCIAL_PLANNING: "Financial Planning",
    IRA_ROLLOVERS: "IRA Rollovers",
    BILLING: "Billing",
    CLIENT_REPORT: "Client Report",
};
const taskTypeLabelTuples = Object.entries(taskTypeLabelObject).map(([key, value]) => [key, value]);
const taskTypeLabelTuplesV2 = Object.entries(taskTypeLabelObjectV2).map(([key, value]) => [key, value]);
export const mapTaskTypeToLabel = (taskType) => {
    const tuple = taskTypeLabelTuples.find(([thisType, _label]) => thisType === taskType);
    if (tuple === undefined) {
        throw new Error(`Tuple did not have ${taskType}`);
    }
    return tuple[1];
};
export const mapTaskTypeToLabelV2 = (taskType) => {
    const tuple = taskTypeLabelTuplesV2.find(([thisType, _label]) => thisType === taskType);
    if (tuple === undefined) {
        throw new Error(`Tuple did not have ${taskType}`);
    }
    return tuple[1];
};
export const mapLabelToTaskType = (taskLabel) => {
    const tuple = taskTypeLabelTuples.find(([_thisType, label]) => label === taskLabel);
    if (tuple === undefined) {
        throw new Error(`Tuple did not have ${taskLabel}`);
    }
    return tuple[0];
};
export const mapLabelToTaskTypeV2 = (taskLabel) => {
    const tuple = taskTypeLabelTuplesV2.find(([_thisType, label]) => label === taskLabel);
    if (tuple === undefined) {
        throw new Error(`Tuple did not have ${taskLabel}`);
    }
    return tuple[0];
};
/**
 * Task priority
 */
const taskPriortyLabelObject = {
    LOW: "Low",
    MEDIUM: "Medium",
    HIGH: "High",
};
const taskPriorityLabelTuples = Object.entries(taskPriortyLabelObject).map(([key, value]) => [key, value]);
export const mapTaskPriorityToLabel = (taskPriority) => {
    const tuple = taskPriorityLabelTuples.find(([thisType, _label]) => thisType === taskPriority);
    if (tuple === undefined) {
        throw new Error(`Tuple did not have ${taskPriority}`);
    }
    return tuple[1];
};
export const mapLabelToTaskPriority = (taskLabel) => {
    const tuple = taskPriorityLabelTuples.find(([_thisType, label]) => label === taskLabel);
    if (tuple === undefined) {
        throw new Error(`Tuple did not have ${taskLabel}`);
    }
    return tuple[0];
};
//# sourceMappingURL=mappings.js.map